[
    {
        "id": "background",
        "type": "background",
        "paint": {
            "background-color": "#cccccc"
        }
    },
    {
        "id": "earth",
        "type": "fill",
        "source": "base",
        "source-layer": "earth",
        "paint": {
            "fill-color": "#E8E7E1"
        }
    },
    {
        "id": "landuse_residential",
        "type": "fill",
        "source": "base",
        "source-layer": "landuse",
        "filter": [
            "any",
            [
                "==",
                "pmap:kind",
                "residential"
            ]
        ],
        "paint": {
            "fill-color": "#DFDDD9",
            "fill-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.7,
                15,
                1
            ]
        }
    },
    {
        "id": "landuse_farmland",
        "type": "fill",
        "source": "base",
        "source-layer": "landuse",
        "filter": [
            "any",
            [
                "==",
                "pmap:kind",
                "farmland"
            ]
        ],
        "paint": {
            "fill-color": "#E0E0D3",
            "fill-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                5,
                0.4,
                7,
                1
            ]
        }
    },
    {
        "id": "landuse_park",
        "type": "fill",
        "source": "base",
        "source-layer": "landuse",
        "filter": [
            "any",
            [
                "in",
                "pmap:kind",
                "park",
                "cemetery",
                "forest",
                "golf_course"
            ]
        ],
        "paint": {
            "fill-color": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                0,
                "#ECEDE4",
                12,
                "#D8DCC0"
            ],
            "fill-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.2,
                14,
                1
            ]
        }
    },
    {
        "id": "landuse_urban_green",
        "type": "fill",
        "source": "base",
        "source-layer": "landuse",
        "filter": [
            "any",
            [
                "in",
                "pmap:kind",
                "allotments",
                "village_green",
                "playground"
            ]
        ],
        "paint": {
            "fill-color": "#D8DCC0",
            "fill-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.2,
                14,
                1
            ]
        }
    },
    {
        "id": "landuse_hospital",
        "type": "fill",
        "source": "base",
        "source-layer": "landuse",
        "filter": [
            "any",
            [
                "==",
                "pmap:kind",
                "hospital"
            ]
        ],
        "paint": {
            "fill-color": "#DFDDD9",
            "fill-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.2,
                14,
                1
            ]
        }
    },
    {
        "id": "landuse_industrial",
        "type": "fill",
        "source": "base",
        "source-layer": "landuse",
        "filter": [
            "any",
            [
                "==",
                "pmap:kind",
                "industrial"
            ]
        ],
        "paint": {
            "fill-color": "#DAD6D6",
            "fill-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.2,
                14,
                1
            ]
        }
    },
    {
        "id": "landuse_school",
        "type": "fill",
        "source": "base",
        "source-layer": "landuse",
        "filter": [
            "any",
            [
                "in",
                "pmap:kind",
                "school",
                "university",
                "college"
            ]
        ],
        "paint": {
            "fill-color": "#DFDDD9",
            "fill-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.2,
                14,
                1
            ]
        }
    },
    {
        "id": "landuse_beach",
        "type": "fill",
        "source": "base",
        "source-layer": "landuse",
        "filter": [
            "any",
            [
                "in",
                "pmap:kind",
                "beach"
            ]
        ],
        "paint": {
            "fill-color": "#e8e4d0",
            "fill-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.2,
                14,
                1
            ]
        }
    },
    {
        "id": "landuse_zoo",
        "type": "fill",
        "source": "base",
        "source-layer": "landuse",
        "filter": [
            "any",
            [
                "in",
                "pmap:kind",
                "zoo"
            ]
        ],
        "paint": {
            "fill-color": "#DAD6D6",
            "fill-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.2,
                14,
                1
            ]
        }
    },
    {
        "id": "landuse_military",
        "type": "fill",
        "source": "base",
        "source-layer": "landuse",
        "filter": [
            "any",
            [
                "in",
                "pmap:kind",
                "military",
                "naval_base",
                "airfield"
            ]
        ],
        "paint": {
            "fill-color": "#DAD6D6",
            "fill-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.2,
                14,
                1
            ]
        }
    },
    {
        "id": "natural_wood",
        "type": "fill",
        "source": "base",
        "source-layer": "natural",
        "filter": [
            "any",
            [
                "in",
                "pmap:kind",
                "wood",
                "forest"
            ]
        ],
        "paint": {
            "fill-color": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                0,
                "#E4E5DF",
                12,
                "#CCD49F"
            ]
        }
    },
    {
        "id": "natural_scrub",
        "type": "fill",
        "source": "base",
        "source-layer": "natural",
        "filter": [
            "in",
            "pmap:kind",
            "scrub",
            "grassland",
            "grass"
        ],
        "paint": {
            "fill-color": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                0,
                "#CCD49F",
                12,
                "#C8D8AB"
            ]
        }
    },
    {
        "id": "natural_glacier",
        "type": "fill",
        "source": "base",
        "source-layer": "natural",
        "filter": [
            "==",
            "pmap:kind",
            "glacier"
        ],
        "paint": {
            "fill-color": "#e7e7e7"
        }
    },
    {
        "id": "natural_sand",
        "type": "fill",
        "source": "base",
        "source-layer": "natural",
        "filter": [
            "==",
            "pmap:kind",
            "sand"
        ],
        "paint": {
            "fill-color": "#e2e0d7"
        }
    },
    {
        "id": "landuse_aerodrome",
        "type": "fill",
        "source": "base",
        "source-layer": "landuse",
        "filter": [
            "any",
            [
                "in",
                "pmap:kind",
                "aerodrome"
            ]
        ],
        "paint": {
            "fill-color": "#dadbdf",
            "fill-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.2,
                14,
                1
            ]
        }
    },
    {
        "id": "transit_runway",
        "type": "line",
        "source": "base",
        "source-layer": "transit",
        "filter": [
            "any",
            [
                "in",
                "pmap:kind_detail",
                "runway"
            ]
        ],
        "paint": {
            "line-color": "#e9e9ed",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                10,
                0,
                12,
                4,
                18,
                30
            ]
        }
    },
    {
        "id": "transit_taxiway",
        "type": "line",
        "source": "base",
        "source-layer": "transit",
        "minzoom": 13,
        "filter": [
            "any",
            [
                "in",
                "pmap:kind_detail",
                "taxiway"
            ]
        ],
        "paint": {
            "line-color": "#e9e9ed",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                13,
                0,
                13.5,
                1,
                15,
                6
            ]
        }
    },
    {
        "id": "hillshade",
        "type": "hillshade",
        "source": "dem",
        "layout": {
            "visibility": "visible"
        },
        "paint": {
            "hillshade-shadow-color": "#473B24"
        }
    },
    {
        "id": "water",
        "type": "fill",
        "source": "base",
        "source-layer": "water",
        "paint": {
            "fill-color": "#B5D1E0"
        }
    },
    {
        "id": "physical_line_stream",
        "type": "line",
        "source": "base",
        "source-layer": "physical_line",
        "minzoom": 14,
        "filter": [
            "all",
            [
                "in",
                "pmap:kind",
                "stream"
            ]
        ],
        "paint": {
            "line-color": "#B5D1E0",
            "line-width": 0.5
        }
    },
    {
        "id": "physical_line_river",
        "type": "line",
        "source": "base",
        "source-layer": "physical_line",
        "minzoom": 9,
        "filter": [
            "all",
            [
                "in",
                "pmap:kind",
                "river"
            ]
        ],
        "paint": {
            "line-color": "#B5D1E0",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                9,
                0,
                9.5,
                1,
                18,
                12
            ]
        }
    },
    {
        "id": "landuse_pedestrian",
        "type": "fill",
        "source": "base",
        "source-layer": "landuse",
        "filter": [
            "any",
            [
                "==",
                "pmap:kind",
                "pedestrian"
            ]
        ],
        "paint": {
            "fill-color": "#FAF9F9",
            "fill-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                12,
                0.1,
                16,
                1
            ]
        }
    },
    {
        "id": "landuse_pier",
        "type": "fill",
        "source": "base",
        "source-layer": "landuse",
        "filter": [
            "any",
            [
                "==",
                "pmap:kind",
                "pier"
            ]
        ],
        "paint": {
            "fill-color": "#e0e0e0",
            "fill-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.2,
                14,
                1
            ]
        }
    },
    {
        "id": "roads_tunnels_other_casing",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "<",
                "pmap:level",
                0
            ],
            [
                "in",
                "pmap:kind",
                "other",
                "path"
            ]
        ],
        "paint": {
            "line-color": "#e0e0e0",
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                14,
                0,
                20,
                7
            ],
            "line-dasharray": [
                1,
                1
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_tunnels_minor_casing",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "<",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "minor_road"
            ]
        ],
        "paint": {
            "line-color": "#e0e0e0",
            "line-dasharray": [
                3,
                2
            ],
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                11,
                0,
                12.5,
                0.5,
                15,
                2,
                18,
                11
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                12,
                0,
                12.5,
                1
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_tunnels_link_casing",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "<",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:link",
                1
            ]
        ],
        "paint": {
            "line-color": "#e0e0e0",
            "line-dasharray": [
                3,
                2
            ],
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                13,
                0,
                13.5,
                1,
                18,
                11
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                12,
                0,
                12.5,
                1
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_tunnels_medium_casing",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "<",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "medium_road"
            ]
        ],
        "paint": {
            "line-color": "#e0e0e0",
            "line-dasharray": [
                3,
                2
            ],
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                7,
                0,
                7.5,
                0.5,
                18,
                13
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                10,
                0,
                10.5,
                1
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_tunnels_major_casing",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "<",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "major_road"
            ]
        ],
        "paint": {
            "line-color": "#e0e0e0",
            "line-dasharray": [
                3,
                2
            ],
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                7,
                0,
                7.5,
                0.5,
                18,
                13
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                9,
                0,
                9.5,
                1
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_tunnels_highway_casing",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "<",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "highway"
            ],
            [
                "!=",
                "pmap:link",
                1
            ]
        ],
        "paint": {
            "line-color": "#e0e0e0",
            "line-dasharray": [
                6,
                0.5
            ],
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                3,
                0,
                3.5,
                0.5,
                18,
                15
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                7,
                0,
                7.5,
                1,
                20,
                15
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_tunnels_other",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "<",
                "pmap:level",
                0
            ],
            [
                "in",
                "pmap:kind",
                "other",
                "path"
            ]
        ],
        "paint": {
            "line-color": "#F5F4F4",
            "line-dasharray": [
                4.5,
                0.5
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                14,
                0,
                20,
                7
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                13,
                0.1,
                15,
                0.6
            ]
        }
    },
    {
        "id": "roads_tunnels_minor",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "<",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "minor_road"
            ]
        ],
        "paint": {
            "line-color": "#FFFFFF",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                11,
                0,
                12.5,
                0.5,
                15,
                2,
                18,
                11
            ],
            "line-dasharray": [
                1,
                1
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                13,
                0.1,
                15,
                0.6
            ]
        }
    },
    {
        "id": "roads_tunnels_link",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "<",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:link",
                1
            ]
        ],
        "paint": {
            "line-color": "#FFFFFF",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                13,
                0,
                13.5,
                1,
                18,
                11
            ],
            "line-dasharray": [
                1,
                1
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                13,
                0.1,
                15,
                0.6
            ]
        }
    },
    {
        "id": "roads_tunnels_medium",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "<",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "medium_road"
            ]
        ],
        "paint": {
            "line-color": "#F5F4F4",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                7,
                0,
                12,
                1.2,
                15,
                3,
                18,
                13
            ],
            "line-dasharray": [
                1,
                1
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                13,
                0.1,
                15,
                0.6
            ]
        }
    },
    {
        "id": "roads_tunnels_major",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "<",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "major_road"
            ]
        ],
        "paint": {
            "line-color": "#F5F4F4",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                6,
                0,
                12,
                1.6,
                15,
                3,
                18,
                13
            ],
            "line-dasharray": [
                1,
                1
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                13,
                0.1,
                15,
                0.6
            ]
        }
    },
    {
        "id": "roads_tunnels_highway",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "<",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "highway"
            ],
            [
                "!=",
                "pmap:link",
                1
            ]
        ],
        "paint": {
            "line-color": "#F5F4F4",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                3,
                0,
                6,
                1.1,
                12,
                1.6,
                15,
                5,
                18,
                15
            ],
            "line-dasharray": [
                1,
                1
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                13,
                0.1,
                15,
                0.6
            ]
        }
    },
    {
        "id": "buildings",
        "type": "fill",
        "source": "base",
        "source-layer": "buildings",
        "paint": {
            "fill-color": "#A9A59A",
            "fill-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                11,
                0.1,
                15,
                1
            ]
        }
    },
    {
        "id": "transit_pier",
        "type": "line",
        "source": "base",
        "source-layer": "transit",
        "filter": [
            "any",
            [
                "==",
                "pmap:kind",
                "pier"
            ]
        ],
        "paint": {
            "line-color": "#e0e0e0",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                12,
                0,
                12.5,
                0.5,
                20,
                16
            ]
        }
    },
    {
        "id": "roads_minor_service_casing",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "minzoom": 13,
        "filter": [
            "all",
            [
                "==",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "minor_road"
            ],
            [
                "==",
                "pmap:kind_detail",
                "service"
            ]
        ],
        "paint": {
            "line-color": "#C1C1C1",
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                13,
                0,
                18,
                8
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                13,
                0,
                13.5,
                0.8
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_minor_casing",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "==",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "minor_road"
            ],
            [
                "!=",
                "pmap:kind_detail",
                "service"
            ]
        ],
        "paint": {
            "line-color": "#AAA7A4",
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                11,
                0,
                12.5,
                0.5,
                15,
                2,
                18,
                11
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                12,
                0,
                12.5,
                1
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        },
        "minzoom": 12
    },
    {
        "id": "roads_link_casing",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "minzoom": 13,
        "filter": [
            "all",
            [
                "==",
                "pmap:link",
                1
            ]
        ],
        "paint": {
            "line-color": "#AAA7A4",
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                13,
                0,
                13.5,
                1,
                18,
                11
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                13,
                0,
                13.5,
                1.5
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_medium_casing",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "==",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "medium_road"
            ]
        ],
        "paint": {
            "line-color": "#B9AA81",
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                7,
                0,
                12,
                1.2,
                15,
                3,
                18,
                13
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                10,
                0,
                10.5,
                1.5
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        },
        "minzoom": 12
    },
    {
        "id": "roads_major_casing_late",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "minzoom": 12,
        "filter": [
            "all",
            [
                "==",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "major_road"
            ]
        ],
        "paint": {
            "line-color": "#BA9875",
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                6,
                0,
                12,
                1.6,
                15,
                3,
                18,
                13
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                9,
                0,
                9.5,
                1
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_highway_casing_late",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "minzoom": 12,
        "filter": [
            "all",
            [
                "==",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "highway"
            ],
            [
                "!=",
                "pmap:link",
                1
            ]
        ],
        "paint": {
            "line-color": "#DDA38C",
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                3,
                0,
                3.5,
                0.5,
                18,
                15
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                7,
                0,
                7.5,
                1,
                20,
                15
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_pedestrian",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "==",
                "pmap:level",
                0
            ],
            [
                "in",
                "pmap:kind_detail",
                "pedestrian",
                "living_street"
            ]
        ],
        "paint": {
            "line-color": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                11,
                "#A2A0A0",
                15,
                "#ffffff"
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                12,
                0.1,
                12.5,
                0.5,
                15,
                2,
                18,
                11
            ]
        }
    },
    {
        "id": "roads_other",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "==",
                "pmap:level",
                0
            ],
            [
                "in",
                "pmap:kind",
                "other",
                "path"
            ]
        ],
        "paint": {
            "line-color": "#ffffff",
            "line-dasharray": [
                3,
                1
            ],
            "line-width": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                12,
                0,
                20,
                2
            ]
        }
    },
    {
        "id": "roads_link",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "==",
                "pmap:link",
                1
            ]
        ],
        "paint": {
            "line-color": "#ffffff",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                13,
                0,
                13.5,
                1,
                18,
                11
            ]
        }
    },
    {
        "id": "roads_minor_service",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "==",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "minor_road"
            ],
            [
                "==",
                "pmap:kind_detail",
                "service"
            ]
        ],
        "paint": {
            "line-color": "#ffffff",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                13,
                0,
                18,
                8
            ]
        }
    },
    {
        "id": "roads_minor",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "==",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "minor_road"
            ],
            [
                "!=",
                "pmap:kind_detail",
                "service"
            ]
        ],
        "paint": {
            "line-color": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                11,
                "#ffffff",
                16,
                "#ffffff"
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                11,
                0,
                12.5,
                0.5,
                15,
                2,
                18,
                11
            ]
        }
    },
    {
        "id": "roads_medium",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "==",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "medium_road"
            ]
        ],
        "paint": {
            "line-color": "#FCF7E7",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                7,
                0,
                12,
                1.2,
                15,
                3,
                18,
                13
            ]
        }
    },
    {
        "id": "roads_major_casing_early",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "maxzoom": 12,
        "filter": [
            "all",
            [
                "==",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "major_road"
            ]
        ],
        "paint": {
            "line-color": "#E0B585",
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                7,
                0,
                7.5,
                0.5,
                18,
                13
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                9,
                0,
                9.5,
                1
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_major",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "==",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "major_road"
            ]
        ],
        "paint": {
            "line-color": "#F2E2CF",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                6,
                0,
                12,
                1.6,
                15,
                3,
                18,
                13
            ]
        }
    },
    {
        "id": "roads_highway_casing_early",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "maxzoom": 12,
        "filter": [
            "all",
            [
                "==",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "highway"
            ],
            [
                "!=",
                "pmap:link",
                1
            ]
        ],
        "paint": {
            "line-color": "#DDA38C",
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                3,
                0,
                3.5,
                0.5,
                18,
                15
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                7,
                0,
                7.5,
                1
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_highway",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                "==",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "highway"
            ],
            [
                "!=",
                "pmap:link",
                1
            ]
        ],
        "paint": {
            "line-color": "#F0CEC1",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                3,
                0,
                6,
                1.1,
                12,
                1.6,
                15,
                5,
                18,
                15
            ]
        }
    },
    {
        "id": "transit_railway",
        "type": "line",
        "source": "base",
        "source-layer": "transit",
        "filter": [
            "all",
            [
                "==",
                "pmap:kind",
                "rail"
            ]
        ],
        "paint": {
            "line-dasharray": [
                0.3,
                0.75
            ],
            "line-opacity": 0.5,
            "line-color": "#745F4C",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                3,
                0,
                6,
                0.15,
                18,
                9
            ]
        }
    },
    {
        "id": "roads_bridges_other_casing",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "minzoom": 12,
        "filter": [
            "all",
            [
                ">",
                "pmap:level",
                0
            ],
            [
                "in",
                "pmap:kind",
                "other",
                "path"
            ]
        ],
        "paint": {
            "line-color": "#e0e0e0",
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                14,
                0,
                20,
                7
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_bridges_link_casing",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "minzoom": 12,
        "filter": [
            "all",
            [
                ">",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:link",
                1
            ]
        ],
        "paint": {
            "line-color": "#e0e0e0",
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                13,
                0,
                13.5,
                1,
                18,
                11
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                12,
                0,
                12.5,
                1.5
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_bridges_minor_casing",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "minzoom": 12,
        "filter": [
            "all",
            [
                ">",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "minor_road"
            ]
        ],
        "paint": {
            "line-color": "#e0e0e0",
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                11,
                0,
                12.5,
                0.5,
                15,
                2,
                18,
                11
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                13,
                0,
                13.5,
                0.8
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_bridges_medium_casing",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "minzoom": 12,
        "filter": [
            "all",
            [
                ">",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "medium_road"
            ]
        ],
        "paint": {
            "line-color": "#E9D7AA",
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                7,
                0,
                12,
                1.2,
                15,
                3,
                18,
                13
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                10,
                0,
                10.5,
                1.5
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_bridges_major_casing",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "minzoom": 12,
        "filter": [
            "all",
            [
                ">",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "major_road"
            ]
        ],
        "paint": {
            "line-color": "#BA9875",
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                7,
                0,
                7.5,
                0.5,
                18,
                10
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                9,
                0,
                9.5,
                1.5
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_bridges_other",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "minzoom": 12,
        "filter": [
            "all",
            [
                ">",
                "pmap:level",
                0
            ],
            [
                "in",
                "pmap:kind",
                "other",
                "path"
            ]
        ],
        "paint": {
            "line-color": "#ebebeb",
            "line-dasharray": [
                2,
                1
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                14,
                0,
                20,
                7
            ]
        }
    },
    {
        "id": "roads_bridges_minor",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "minzoom": 12,
        "filter": [
            "all",
            [
                ">",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "minor_road"
            ]
        ],
        "paint": {
            "line-color": "#ffffff",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                11,
                0,
                12.5,
                0.5,
                15,
                2,
                18,
                11
            ]
        }
    },
    {
        "id": "roads_bridges_link",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "minzoom": 12,
        "filter": [
            "all",
            [
                ">",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:link",
                1
            ]
        ],
        "paint": {
            "line-color": "#ffffff",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                13,
                0,
                13.5,
                1,
                18,
                11
            ]
        }
    },
    {
        "id": "roads_bridges_medium",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "minzoom": 12,
        "filter": [
            "all",
            [
                ">",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "medium_road"
            ]
        ],
        "paint": {
            "line-color": "#FCF7E7",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                7,
                0,
                12,
                1.2,
                15,
                3,
                18,
                13
            ]
        }
    },
    {
        "id": "roads_bridges_major",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "minzoom": 12,
        "filter": [
            "all",
            [
                ">",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "major_road"
            ]
        ],
        "paint": {
            "line-color": "#F2E2CF",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                6,
                0,
                12,
                1.6,
                15,
                3,
                18,
                13
            ]
        }
    },
    {
        "id": "roads_bridges_highway_casing",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "minzoom": 12,
        "filter": [
            "all",
            [
                ">",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "highway"
            ],
            [
                "!=",
                "pmap:link",
                1
            ]
        ],
        "paint": {
            "line-color": "#DDA38C",
            "line-gap-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                3,
                0,
                3.5,
                0.5,
                18,
                15
            ],
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                7,
                0,
                7.5,
                1,
                20,
                15
            ],
            "line-opacity": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                7,
                0.1,
                12,
                1
            ]
        }
    },
    {
        "id": "roads_bridges_highway",
        "type": "line",
        "source": "base",
        "source-layer": "roads",
        "filter": [
            "all",
            [
                ">",
                "pmap:level",
                0
            ],
            [
                "==",
                "pmap:kind",
                "highway"
            ],
            [
                "!=",
                "pmap:link",
                1
            ]
        ],
        "paint": {
            "line-color": "#F0CEC1",
            "line-width": [
                "interpolate",
                [
                    "exponential",
                    1.6
                ],
                [
                    "zoom"
                ],
                3,
                0,
                6,
                1.1,
                12,
                1.6,
                15,
                5,
                18,
                15
            ]
        }
    },
    {
        "id": "physical_line_waterway_label",
        "type": "symbol",
        "source": "base",
        "source-layer": "physical_line",
        "minzoom": 13,
        "filter": [
            "all",
            [
                "in",
                "pmap:kind",
                "river",
                "stream"
            ]
        ],
        "layout": {
            "symbol-placement": "line",
            "text-font": [
                "BarlowCondensed-Regular"
            ],
            "text-field": [
                "get",
                "name"
            ],
            "text-size": 12,
            "text-letter-spacing": 0.3
        },
        "paint": {
            "text-color": "#ffffff"
        }
    },
    {
        "id": "physical_point_peak",
        "type": "symbol",
        "source": "base",
        "source-layer": "physical_point",
        "filter": [
            "any",
            [
                "==",
                "pmap:kind",
                "peak"
            ]
        ],
        "layout": {
            "text-font": [
                "BarlowCondensed-Italic"
            ],
            "text-field": [
                "get",
                "name"
            ],
            "text-size": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                10,
                8,
                16,
                12
            ],
            "text-letter-spacing": 0.1,
            "text-max-width": 9
        },
        "paint": {
            "text-color": "#7e9aa0",
            "text-halo-width": 1.5
        }
    },
    {
        "id": "roads_labels_minor",
        "type": "symbol",
        "source": "base",
        "source-layer": "roads",
        "minzoom": 15,
        "filter": [
            "any",
            [
                "in",
                "pmap:kind",
                "minor_road",
                "other",
                "path"
            ]
        ],
        "layout": {
            "symbol-sort-key": [
                "get",
                "pmap:min_zoom"
            ],
            "symbol-placement": "line",
            "text-font": [
                "BarlowCondensed-Regular"
            ],
            "text-field": [
                "get",
                "name"
            ],
            "text-size": 12
        },
        "paint": {
            "text-color": "#91888b",
            "text-halo-color": "#ffffff",
            "text-halo-width": 2
        }
    },
    {
        "id": "physical_point_ocean",
        "type": "symbol",
        "source": "base",
        "source-layer": "physical_point",
        "filter": [
            "any",
            [
                "in",
                "pmap:kind",
                "sea",
                "ocean",
                "lake",
                "water",
                "bay",
                "strait",
                "fjord"
            ]
        ],
        "layout": {
            "text-font": [
                "BarlowCondensed-Medium"
            ],
            "text-field": [
                "get",
                "name"
            ],
            "text-size": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                3,
                10,
                10,
                12
            ],
            "text-letter-spacing": 0.1,
            "text-max-width": 9,
            "text-transform": "uppercase"
        },
        "paint": {
            "text-color": "#ffffff"
        }
    },
    {
        "id": "physical_point_lakes",
        "type": "symbol",
        "source": "base",
        "source-layer": "physical_point",
        "filter": [
            "any",
            [
                "in",
                "pmap:kind",
                "lake",
                "water"
            ]
        ],
        "layout": {
            "text-font": [
                "BarlowCondensed-Medium"
            ],
            "text-field": [
                "get",
                "name"
            ],
            "text-size": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                3,
                0,
                6,
                12,
                10,
                12
            ],
            "text-letter-spacing": 0.1,
            "text-max-width": 9
        },
        "paint": {
            "text-color": "#ffffff"
        }
    },
    {
        "id": "roads_labels_major",
        "type": "symbol",
        "source": "base",
        "source-layer": "roads",
        "minzoom": 11,
        "filter": [
            "any",
            [
                "in",
                "pmap:kind",
                "highway",
                "major_road",
                "medium_road"
            ]
        ],
        "layout": {
            "symbol-sort-key": [
                "get",
                "pmap:min_zoom"
            ],
            "symbol-placement": "line",
            "text-font": [
                "BarlowCondensed-Regular"
            ],
            "text-field": [
                "get",
                "name"
            ],
            "text-size": 12
        },
        "paint": {
            "text-color": "#938a8d",
            "text-halo-color": "#ffffff",
            "text-halo-width": 2
        }
    }
]